import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { RightColumnProvider } from 'Context/RightColumnContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import ScenarioSelectionRedefinedWrapperTemplateBody
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioSelectionRedefinedWrapperTemplateBody';
import {
  SelectScenarioContextProvider,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/SelectScenarioContext';
import classNames from 'classnames';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const useStyles = makeStyles(theme => ({
  height: {
    height: '100dvh',
    overflow: 'auto',
  },
  mobileHeight: {
    height: `calc(100dvh - ${theme.heights.mobileBottomNavigationHeight}px)`,
  },
  newNavHeight: {
    height: `calc(100dvh - ${theme.heights.desktopTopNavigationHeight}px)`,
  },
}));

const ScenarioSelectionRedefinedWrapperTemplate = ({
  resource,
  layout,
  metaOverrideSet,
  showBottomStepNavigators,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();
  const newNavPresent = true;

  const { setPageContentCollection } = usePageContentContext();
  // Since we are in the scenario selection wizard we should submit the current wizard step after we successfully select
  // so that we can navigate forward to the next relevant step
  const onSelectSuccess = async (_) => {
    const updatedColl = await resource.submit();
    await setPageContentCollection(updatedColl);
  };

  useBoneBackgroundColor();

  return (
    <SelectScenarioContextProvider onSelectSuccess={onSelectSuccess}>
      <RightColumnProvider>
        <Box className={classNames(classes.height, {
          [classes.mobileHeight]: isMobile,
          [classes.newNavHeight]: !isMobile && newNavPresent,
        })}
        >
          <ScenarioSelectionRedefinedWrapperTemplateBody
            resource={resource}
            layout={layout}
            metaOverrideSet={metaOverrideSet}
            showBottomStepNavigators={showBottomStepNavigators}
          />
        </Box>
      </RightColumnProvider>
    </SelectScenarioContextProvider>
  );
};

ScenarioSelectionRedefinedWrapperTemplate.defaultProps = {
  metaOverrideSet: undefined,
  showBottomStepNavigators: true,
};

ScenarioSelectionRedefinedWrapperTemplate.propTypes = {
  /** layout: The body content layout * */
  layout: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.node]).isRequired,
  /** metaOverrideSet: A meta override set * */
  metaOverrideSet: PropTypes.object,
  /** resource: The displayed resource * */
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  showBottomStepNavigators: PropTypes.bool,
};

export default ScenarioSelectionRedefinedWrapperTemplate;
